import React, { createContext, useCallback, useContext, useState } from "react";
import Toast, { ToastVariant } from "../components/shared/Toast";

interface ToastState {
  open: boolean;
  message: string;
  variant: ToastVariant;
}

interface ToastContextValue {
  showToast: (message: string, variant?: ToastVariant) => void;
}

const ToastContext = createContext<ToastContextValue>({ showToast: () => {} });

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  const [toast, setToast] = useState<ToastState>({
    open: false,
    message: "",
    variant: "success",
  });

  const showToast = useCallback((message: string, variant: ToastVariant = "success") => {
    setToast({ open: true, message, variant });
  }, []);

  const handleClose = useCallback(() => {
    setToast((prev) => ({ ...prev, open: false }));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toast
        open={toast.open}
        message={toast.message}
        variant={toast.variant}
        onClose={handleClose}
      />
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
